import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { ValidatorFn,FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

//import constants
import { AppFrontRoutes } from '../../../../../constants/app-front-routes';

//import validators
import { ValidateExtension } from '../../../../../validators/extension.validator';
import { ValidateUniquePlancode } from '../../../../../validators/uniquePlancode.validator';

//import services
import { GeneralService } from '../../../../../services/general.service';
import { ServicingService } from '../../../../../services/servicing.service';
import { MeasurementService } from '../../../../../services/measurement.service';

import { exit } from 'process';
import { NotifyValid } from '../../../../../validators/notifyValid.validator';

  
// const MyAwesomeRangeValidator: ValidatorFn = (fg: FormGroup) => {
//   const start = fg.get('how_often_value').value;
//   // console.log(start);
//   const end = fg.get('days_notify').value;
//   return start !== null && end !== null && start < end
//   ? null
//   : { range: true };
  
// };

declare var $: any;

const MyAwesomeRangeValidator: ValidatorFn = (fg: FormGroup) => {
  const how_often_value = fg.get('how_often_value').value;
  const how_often_frequency = fg.get('how_often_frequency').value;
  const days_notify = fg.get('days_notify').value;


  // return how_often_value !== null && days_notify !== null && how_often_value < days_notify
  //   ? null
  //   : { range: true };

  var sa;
  if (how_often_value != "") {
     sa = fg.get('how_often_value').value;
  }
  
  var sb = how_often_frequency;
  if (sb == "Weeks") {
    sa = sa * 7;
  }
  else if (sb == "Months") {
    sa = sa * 30;
  }
  else if (sb == "Years") {
    sa = sa * 365;
  }

  var common = new Date();

  var first = new Date();
  first.setDate(common.getDate() + parseInt(sa)); 

  var second = new Date();
  second.setDate(common.getDate() + parseInt(days_notify));
  
  // console.log(first);
  // console.log(second);

  return first > second  ? null   : { range: true };
};


@Component({
  selector: 'app-measurement-createcalibration',
  templateUrl: './measurement-createcalibration.component.html',
  styleUrls: ['./measurement-createcalibration.component.css']
})


export class MeasurementCreateCalibrationComponent implements OnInit {

  @Input() ID: string;
  @Input() langs: string;


  @ViewChild('imagePreviewRef') imagePreviewRef: ElementRef;
  frequencyConfig: any;
  notificationConfig: any;
  planConfig: any;
  emp_id: any;
  modalTitle: string;

  lang: any;
  generalLang: any;
  record: any;
  mode: string;
  notification_time: any;
  equipment_val: any;
  equipment_name: any;

  imageLink: any;
  sitems: any;
  plan_id: any;
  id: any;

  createForm: FormGroup;
  createFormSubmitted: Boolean = false;
  createFormErrorMsg: any;

  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};

  constructor(
    private formBuilder: FormBuilder,
    private generalService: GeneralService,
    private servicingService: ServicingService,
    private measurementService: MeasurementService,    
    private router: Router,
    private validateUniquePlancode: ValidateUniquePlancode,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    // this.FormBuild();
    this.getData();
    this.config();
    this.fileDesign();

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableCheckAll: false,
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

    //   { item_id: this.equipment_name, item_text: this.equipment_val }
    // ];

  }




  config(): void {


    this.frequencyConfig = [
      { value: 'Days', text: 'Days' },
      { value: 'Weeks', text: 'Weeks' },
      { value: 'Months', text: 'Months' },
      { value: 'Years', text: 'Years' }
    ];



    this.planConfig = [
      { value: '7', text: '33 - e3' },
      { value: '18', text: 'sarda - add' },
      { value: '145', text: 'S 001 - test' }
    ];


    // this.notificationConfig = [
    //   { value: '886', text: this.notification_time }
    // ];

  }



  FormBuild(): void {

    this.createForm = this.formBuilder.group({
      plan_code:
        ['',
          [Validators.required]
        ],
      plan_description: ['', [Validators.required]],
      how_often_value: [null, [Validators.required]],
      how_often_frequency: ['', [Validators.required]],
      days_notify: [null, [Validators.required]],
      notification_time: ['', [Validators.required]],
      equipment_to_which_plan: ['', [Validators.required]],
      send_email: this.formBuilder.array([this.newEmail()]),
      plan_id: '',
      action: 'plans_save',
    }, { validator: MyAwesomeRangeValidator });


    
    // setTimeout(() => this.fileDesign(), 10);

  }

  FormBuildUpdate(): void {
    this.emptyEmail();
    let emails = this.record.send_email.split(',');

    this.createForm.controls['plan_code'].setAsyncValidators(this.validateUniquePlancode.createCPValidator(this.record.plan_id));


    this.createForm.patchValue({
      plan_code: this.record.plan_code,
      plan_description: this.record.plan_description,
      how_often_value: this.record.how_often_value,
      how_often_frequency: this.record.how_often_frequency,
      days_notify: this.record.days_notify,
      notification_time: this.record.notification_time1,
      equipment_to_which_plan: this.record.equipment_to_which_plan1,
      plan_id: this.record.plan_id
    });

    if (this.record.send_email) {
      for (const email of emails) {
        this.send_email().push(this.newEmail(email));
      }
    }
    else
      this.send_email().push(this.newEmail());

    // if(this.record.timetable_link) {
    // for (const image of images) {
    // this.timetable_link_uploaded().push(new FormControl(image.split('/').pop()));
    // }
    // }

    // console.log(this.record.serv_attlink);



    // if (this.record.serv_attlink) {
    //   for (const image of images) {
    //     this.service_attach_uploaded().push(new FormControl(image.split('/').pop()));
    //   }
    // }


    // if (this.record.serv_imglink) {
    //   for (const uimage of simages) {
    //     this.service_image_uploaded().push(new FormControl(uimage.split('/').pop()));
    //   }
    // }



    setTimeout(() => this.fileDesign(), 10);

  }

  send_email(): FormArray {
    return this.createForm.get("send_email") as FormArray
  }

  newEmail(data = ''): FormControl {
    return new FormControl(data, [Validators.required, Validators.email]);
  }


  addEmail() {
    this.send_email().push(this.newEmail());
  }

  removeEmail(i: number) {
    this.send_email().removeAt(i);
  }

  emptyEmail() {
    while (this.send_email().controls.length > 0) {
      this.send_email().removeAt(0);
    }
  }

  ref_email(): FormArray {
    return this.createForm.get('ref_email') as FormArray;
  };


  service_attach_exists(): FormArray {
    return this.createForm.get('service_attach_exists') as FormArray;
  };


  service_image_exists(): FormArray {
    return this.createForm.get('service_image_exists') as FormArray;
  };



  newAttachment(): FormGroup {
    return this.formBuilder.group({
      email: ['', [<any>Validators.required, <any>Validators.email]]
    });
  }

  addAttachment(): void {
    this.ref_email().push(this.newAttachment());
  }

  removeAttachment(i: number) {
    this.ref_email().removeAt(i);
  }

  // timetable_link_uploaded(): FormArray {
  // return this.createForm.get('timetable_link_uploaded') as FormArray;
  // };

  // removeAttachmentUploaded(i: number) {
  // this.timetable_link_uploaded().removeAt(i);
  // }

  service_attach_uploaded(): FormArray {
    return this.createForm.get('service_attach_uploaded') as FormArray;
  };

  removeAttachmentUploaded(i: number) {
    this.service_attach_uploaded().removeAt(i);
  }

  service_image_uploaded(): FormArray {
    return this.createForm.get('service_image_uploaded') as FormArray;
  };

  removeAttachmentUploaded1(i: number) {
    this.service_image_uploaded().removeAt(i);
  }



  public selectAttachment(event: any, index) {

    this.createForm.value.service_image_exists[index].link = File;

    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.createForm.value.service_image_exists[index].link = { 'name': file.name, 'image': reader.result };
      };
    }

  }


  public selectAttachment1(event: any, index) {

    this.createForm.value.service_attach_exists[index].link = File;

    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.createForm.value.service_attach_exists[index].link = { 'name': file.name, 'image': reader.result };
      };
    }

  }

  fileDesign() {
    $(".filestyle").filestyle({
      'htmlIcon': '<i class="fa fa-inbox mr-5"></i>',
      'btnClass': 'btn-default',
    });
  }

  formErrorClass(value, submitted): string {
    return value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
  }

  imagePreview(value) {

    this.imageLink = value;
    this.modalService.show(this.imagePreviewRef, { class: 'modal-lgs' });

  }


  onSubmit() {

    // console.log(this.createForm.value); return false;

    this.createFormSubmitted = true;

    if (this.createForm.invalid)
      return;

    //   console.log('test12'); return false;

    this.measurementService.update_maintenance(this.createForm.value).subscribe(
      res => {

        if (res.status) {
          this.generalService.notify_msg('success', res.msg);
          this.bsModalRef.hide();


          this.router.navigateByUrl('/test', { skipLocationChange: true })
            .then(() => {
              this.router.navigate([AppFrontRoutes.CALIBRATION_PLANS]);
            });

          // setTimeout(() => {
          //   window.location.reload();
          // }, 3000);


        }
        else {
          this.generalService.notify_msg('error', res.msg);
          this.bsModalRef.hide();

          this.router.navigateByUrl('/test', { skipLocationChange: true })
            .then(() => {
              this.router.navigate([AppFrontRoutes.MAINTENANCE_PLANS]);
            });

          // setTimeout(() => {
          //   window.location.reload();
          // }, 3000);

        }



      }
    );

  }



  // getData() {

  //   if (this.ID) 
  //   {
  //   this.mode = 'Edit';
  //   this.modalTitle = 'Edit Servicing';
  //   }
  //   else 
  //   {
  //   this.mode = 'Create';
  //   this.modalTitle = 'Create Servicing';
  //   }
  // }

  getData() {

    // console.log(this.ID); 

    if (this.ID) {
      this.measurementService.editMeasurementformdata(this.ID).subscribe(
        res => {

          if (!res.status) {
            this.generalService.notify_msg('error', 'Some problems in getting details');
            this.bsModalRef.hide();
            return;
          }

          this.lang = this.measurementService.createLang(res);
          // console.log(this.lang);
          this.id = this.ID;
          // this.lang = res.data.language;
          this.record = res.data.record;
          this.notification_time = res.data.record.notification_time;
          this.equipment_val = res.data.record.equipment_to_which_plan;
          // console.log(this.notification_time); return false;
          this.FormBuildUpdate();
        }
      );
      this.generalLang = this.langs;


      this.mode = 'Edit';
      this.modalTitle = this.generalLang.createcalibrationplan;
    }
    else {

      this.measurementService.getMaintenanceformdata()
        .subscribe(
          (res) => {
          this.lang = this.measurementService.createLang(res);
           
            this.notification_time = res.data.notification_time;
            this.equipment_val = res.data.equipment_to_which_plan;
            this.id = '';
            this.plan_id = "";
            this.createForm.controls['plan_code'].setAsyncValidators(this.validateUniquePlancode.createCPValidator(this.plan_id));
            
          }
        );
        this.generalLang = this.langs;


      this.mode = 'Create';
      this.modalTitle = this.generalLang.createcalibrationplan;

    }

    // console.log(this.generalLang.plancodealreadyexists);

    this.createFormErrorMsg = {
      'plan_code': [
        { type: 'required', message: this.generalLang.requiredField },
        { type: 'plancodeTaken', message: this.generalLang.plancodealreadyexists }
      ],
      'plan_description': [{ type: 'required', message: this.generalLang.requiredField }],
      'how_often_value': [
        { type: 'required', message: this.generalLang.requiredField },
        { type: 'pattern', message: this.generalLang.pleaseenteronlydigits }
      ],
      'how_often_frequency': [{ type: 'required', message: this.generalLang.requiredField }],
      'days_notify': [
        { type: 'required', message: this.generalLang.requiredField },
        { type: 'pattern', message: this.generalLang.pleaseenteronlydigits }
      ],
      'notification_time': [{ type: 'required', message: this.generalLang.requiredField }],
      'equipment_to_which_plan': [{ type: 'required', message: this.generalLang.requiredField }],
      'send_email': [
        { type: 'required', message: this.generalLang.requiredField },
        { type: 'email', message: this.generalLang.correctemail }
      ],
    }

    this.FormBuild();
  }

  close(ID:any)
  {
    if (ID == "") {
      if (confirm(this.lang.withoutsaving))
        this.bsModalRef.hide();
    }
    else {
      this.bsModalRef.hide();
    }
  }



}
